var _rect, _rect2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanBaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500244,
    y: 1.36755,
    width: 55,
    height: 55,
    rx: 3.5,
    fill: "url(#paint0_linear_66_10552)",
    stroke: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_66_10552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 57
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.000244141,
    y: 0.867554,
    width: 56,
    height: 56,
    rx: 2,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_66_10552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7045 15.4311L20.0994 53.1689C19.6337 53.976 19.3873 54.8909 19.3848 55.8228C19.3823 56.7546 19.6237 57.6709 20.0851 58.4805C20.5465 59.2901 21.2118 59.9648 22.0148 60.4376C22.8178 60.9104 23.7305 61.1648 24.6623 61.1754H69.8752C70.807 61.1648 71.7197 60.9104 72.5227 60.4376C73.3257 59.9648 73.991 59.2901 74.4524 58.4805C74.9138 57.6709 75.1552 56.7546 75.1527 55.8228C75.1502 54.8909 74.9038 53.976 74.4381 53.1689L51.8303 15.4311C51.3543 14.6473 50.6844 13.9994 49.8852 13.5498C49.086 13.1001 48.1844 12.8639 47.2674 12.8639C46.3504 12.8639 45.4489 13.1001 44.6497 13.5498C43.8505 13.9994 43.1806 14.6473 42.7045 15.4311Z",
    stroke: "url(#paint1_linear_66_10552)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      mixBlendMode: "hard-light"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8411 14.4315L9.72473 39.6674C9.41328 40.2071 9.24852 40.8189 9.24684 41.4421C9.24516 42.0652 9.40661 42.6779 9.71515 43.2193C10.0237 43.7607 10.4686 44.2119 11.0055 44.5281C11.5425 44.8442 12.1529 45.0143 12.776 45.0215H43.0106C43.6337 45.0143 44.2441 44.8442 44.7811 44.5281C45.3181 44.2119 45.7629 43.7607 46.0715 43.2193C46.38 42.6779 46.5415 42.0652 46.5398 41.4421C46.5381 40.8189 46.3734 40.2071 46.0619 39.6674L30.9437 14.4315C30.6254 13.9073 30.1774 13.4741 29.643 13.1734C29.1085 12.8727 28.5056 12.7147 27.8924 12.7147C27.2792 12.7147 26.6763 12.8727 26.1419 13.1734C25.6075 13.4741 25.1595 13.9073 24.8411 14.4315Z",
    fill: "url(#paint2_linear_66_10552)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_10552",
    x1: 28.0002,
    y1: 0.867554,
    x2: 28.0002,
    y2: 56.8676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.448324,
    stopColor: "#F5FFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCFFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_66_10552",
    x1: 71.0967,
    y1: 33.9162,
    x2: 19.3848,
    y2: 59.5142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43769B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3368B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_66_10552",
    x1: 37.1476,
    y1: 18.5624,
    x2: 14.9781,
    y2: 45.0214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67C6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EE69F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanBaseIcon);
export default __webpack_public_path__ + "static/media/PlanBaseIcon.66ae8434e9c40a66754d90e80c7cf8fd.svg";
export { ForwardRef as ReactComponent };